import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

/**
 * Stat tab: a large count over a caption with a selected (filled) state.
 * Meant to be used as a group of filters/segments, e.g. inside a `role="tablist"` container.
 */
@Component({
  selector: "ds-stat-tab",
  templateUrl: "./ds-stat-tab.component.html",
  styleUrls: ["./ds-stat-tab.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsStatTabComponent {
  /** Large number shown on top. */
  @Input() count: number | string = 0;
  /** Caption shown under the count. */
  @Input() label = "";
  /** Selected (filled) state. */
  @Input() active = false;
  @Input() disabled = false;
  /** Stretch to take an equal share of a flex row. */
  @Input()
  @HostBinding("class.ds-stat-tab--full-width")
  fullWidth = false;
  /** Shows a pulsing red "live" dot next to the label (e.g. active/en-vivo). */
  @Input() live = false;
  /** Small chip at the top-right of the box (e.g. who owns the stage: "EP", "Eliza"). */
  @Input() badge = "";

  /** Emitted when the user selects the tab. */
  @Output() selected = new EventEmitter<void>();

  onSelect(): void {
    if (!this.disabled) {
      this.selected.emit();
    }
  }
}
